<template>
    <div class="phoneProductCenter">
        <div style="height: 5.29em;width:100%;position: fixed;left: 0;z-index: 10000;
        top: 0;background-color:#fff;" class="flex flex-a-c">
            <img src="../assets/img/logo.png" style="width: 8.33em;height: 1.96em;margin-left: 2.04em;" alt="">
        </div>
        <div style="height: 5.29em;"></div>
        <banner :type="4" :phone="true"></banner>
        <div style="padding: 2.17em 1.46em;">
            <div class="font-600 font-18">定制服务</div>
            <div style="width: 28.33em;height: 0.42em;background: #F7F9FA;border-radius: 2px;margin-top: 1.71em;"></div>
            <div style="margin-top: 1.38rem;">{{productList.desc}}</div>
            <div style="width: 28.33em;height: 0.08em;background: #BD2C2E;border-radius: 2px;margin-top: 1.71em;"></div>
            <div class="flex table">
                <div style="flex: 0 0 5.83em;">项目名称</div>
                <div style="flex: 0 0 7.5em;">产品货号</div>
                <div style="flex: 0 0 5.75em;">产品类别</div>
                <div style="flex: 0 0 9.08em;">应用平台</div>
            </div>
            <div class="flex table" v-for="item in productList.list" :key="item.id">
                <div style="flex: 0 0 5.83em;background: #F7F9FA;">{{item.name}}</div>
                <div style="flex: 0 0 7.5em;">{{item.field1}}</div>
                <div style="flex: 0 0 5.75em;">{{item.field2}}</div>
                <div style="flex: 0 0 9.08em;">{{item.field3}}</div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'pet',
        props: {},
        data() {
            let that = this
            return {
                banner: [],
                productList: {},
                id: that.$route.query.id || 1,
                text: '',
                productName: that.$route.query.name
            }
        },
        async mounted() {
            this.getProductList()
        },
        methods: {
            // 获取产品列表
            async getProductList() {
                this.productList = await this.$api.getCustomizedServicesList2()
            }
        },

    }
</script>
<style scoped lang="scss">
    .phoneProductCenter {
        font-size: 12px;
    }

    .table {
        & > div {
            height: 5.45em;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    /deep/ .swiper-pagination-bullet {
        height: .7em;
        width: .7em;
    }
</style>
